export default function SandboxBadge() {
  // Only check VITE_DUFFEL_MODE - no API key checks in client code
  const isSandbox = (import.meta.env.VITE_DUFFEL_MODE || 'sandbox') === 'sandbox';

  if (!isSandbox) return null;
  return (
    <div className="inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs bg-muted text-muted-foreground border border-border">
      <span className="w-2 h-2 rounded-full bg-yellow-500" />
      Duffel sandbox demo — no live booking made
    </div>
  );
}